import type React from 'react';
import classnames from 'classnames';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './labeled-info.module.less';
import { useUniqueHtmlId } from '../../../hooks/use-unique-html-id';
import { generateDataTestidAttribute } from '../../services/testid-service';

type LabeledInfoProps = {
  children?: React.ReactNode;
  childWrapperClassName?: string;
  className?: string;
  label?: string;
  labelClassName?: string;
  showMdash?: boolean;
};

export const LabeledInfo = ({
  children = emptyArray,
  childWrapperClassName = '',
  className = '',
  label = '',
  labelClassName = '',
  showMdash = false,
}: LabeledInfoProps) => {
  const id = useUniqueHtmlId('labeled-info');
  const testId = `labeled-info-${label.toLowerCase().replace(/\s/g, '-')}`;
  return (
    <div className={classnames(className, style['labeled-info'])} {...generateDataTestidAttribute(testId)}>
      <div className={classnames(style.label, labelClassName)} id={id}>
        {label}
      </div>
      <div aria-labelledby={id} className={classnames(style.content, childWrapperClassName)}>
        {showMdash ? (
          <span className={style.mdash} data-testid='mdash'>
            &mdash;
          </span>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
